import InstitutionalPage from "../../modules/institutional-page/views/institutional-page.vue";
import { PermissionList } from "../../static-data/PermissionList";
import RouterViewRender from "../../utils/routes/router-view-render";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const InstitutionalPageRoutes = {
  path: "pagina-institucional",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.INSTITUTIONAL_PAGE_MENU),
  children: [
    {
      path: "",
      component: InstitutionalPage,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default InstitutionalPageRoutes;
